import script from "./Notifications.vue?vue&type=script&setup=true&lang=ts"
export * from "./Notifications.vue?vue&type=script&setup=true&lang=ts"

import "./Notifications.vue?vue&type=style&index=0&id=1a81f7ad&lang=scss"

const __exports__ = script;

export default __exports__